import colors from './colors';

type Breakpoints = string[] & { [key in 'sm' | 'md' | 'lg' | 'xl']?: string };
const breakpoints: Breakpoints = [
  '40em', //640px
  '52em', //832px
  '64em', //1024px
  '80em', //1280px
  '96em' //1536px
];

breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3];
breakpoints['2xl'] = breakpoints[4];

const space = {
  px: '1px',
  0: '0px',
  0.5: '0.125rem',
  1: '0.25rem',
  1.5: '0.375rem',
  2: '0.5rem',
  2.5: '0.625rem',
  3: '0.75rem',
  3.5: '0.875rem',
  4: '1rem', //16px
  5: '1.25rem',
  6: '1.5rem',
  7: '1.75rem',
  8: '2rem',
  9: '2.25rem',
  10: '2.5rem',
  11: '2.75rem',
  12: '3rem',
  14: '3.5rem',
  16: '4rem',
  20: '5rem',
  24: '6rem',
  28: '7rem',
  32: '8rem',
  36: '9rem',
  40: '10rem',
  44: '11rem',
  48: '12rem',
  52: '13rem',
  56: '14rem',
  60: '15rem',
  64: '16rem',
  72: '18rem',
  80: '20rem',
  96: '24rem'
};

const config = {
  fontSizes: [12, 14, 16, 18, 24, 32, 48, 64, 72],
  space,
  breakpoints,
  colors,
  fonts: {
    body: 'Public Sans',
    monospace: 'Menlo, monospace'
  },
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  sizes: breakpoints
};

export default config;
